/**
 * Official Spanish translations for Pokémon Items (WikiDex/Official Game Localization)
 * Mapping: PokeAPI slug -> Spanish Name
 */
export const ITEMS_ES = {
  // === STRATEGY & COMPETITIVE ===
  'life-orb': 'Vidasfera',
  'leftovers': 'Restos',
  'choice-scarf': 'Pañuelo Elección',
  'choice-band': 'Cinta Elección',
  'choice-specs': 'Gafas Elección',
  'focus-sash': 'Banda Focus',
  'assault-vest': 'Chaleco Asalto',
  'rocky-helmet': 'Casco Dentado',
  'eviolite': 'Mineral Evolutivo',
  'black-sludge': 'Lodo Negro',
  'heavy-duty-boots': 'Botas Suela Dura',
  'weakness-policy': 'Seguro Debilidad',
  'air-balloon': 'Globo Helio',
  'expert-belt': 'Cinturón Experto',
  'muscle-band': 'Cinta Fuerte',
  'wise-glasses': 'Gafas Especiales',
  'flame-orb': 'Llamasfera',
  'toxic-orb': 'Toxisfera',
  'iron-ball': 'Bola de Hierro',
  'covert-cloak': 'Capa Sigilo',
  'clear-amulet': 'Amuleto Claro',
  'booster-energy': 'Energía Potenciadora',
  'light-clay': 'Refleluz',
  'mental-herb': 'Hierba Mental',
  'power-herb': 'Hierba Única',
  'white-herb': 'Hierba Blanca',
  'eject-button': 'Botón Escape',
  'eject-pack': 'Mochila Escape',
  'red-card': 'Tarjeta Roja',
  'shed-shell': 'Muda Concha',
  'loaded-dice': 'Dados Trucados',
  'punching-glove': 'Guante de Boxeo',
  'safety-goggles': 'Goggles de Seguridad',
  'protective-pads': 'Rodilleras Protectoras',
  'utility-umbrella': 'Paraguas Multiuso',
  'bright-powder': 'Polvo Brillo',
  'quick-claw': 'Garra Rápida',
  'scope-lens': 'Periscopio',
  'wide-lens': 'Lupa',
  'zoom-lens': 'Telescopio',
  'king-rock': 'Roca del Rey',
  'razor-claw': 'Garra Afilada',
  'razor-fang': 'Colmillo Agudo',
  'metronome': 'Metrónomo',
  'sticky-barb': 'Tarugo Pegajoso',
  'black-belt': 'Cinturón Negro',
  'silk-scarf': 'Pañuelo de Seda',
  'charcoal': 'Carbón',
  'mystic-water': 'Agua Mística',
  'magnet': 'Imán',
  'never-melt-ice': 'Antiderretir',
  'sharp-beak': 'Pico Afilado',
  'poison-barb': 'Flecha Venenosa',
  'soft-sand': 'Arena Fina',
  'hard-stone': 'Piedra Dura',
  'silver-powder': 'Polvo Plata',
  'spell-tag': 'Hechizo',
  'dragon-fang': 'Colmillo Dragón',
  'black-glasses': 'Gafas de Sol',
  'metal-coat': 'Revestimiento Metálico',
  'twisted-spoon': 'Cuchara Torcida',

  // === MEGA STONES ===
  'abomasite': 'Abomasnowita',
  'absolite': 'Absolita',
  'aerodactylite': 'Aerodactylita',
  'aggronite': 'Aggronita',
  'alakazite': 'Alakazamita',
  'altarianite': 'Altarianita',
  'ampharosite': 'Ampharosita',
  'audinite': 'Audinita',
  'banettite': 'Banettita',
  'beedrillite': 'Beedrillita',
  'blastoisinite': 'Blastoisita',
  'blazikenite': 'Blazikenita',
  'cameruptite': 'Cameruptita',
  'charizardite-x': 'Charizardita X',
  'charizardite-y': 'Charizardita Y',
  'diancite': 'Diancita',
  'galladite': 'Galladita',
  'garchompite': 'Garchompita',
  'gardevoirite': 'Gardevoirita',
  'gengarite': 'Gengarita',
  'glalitite': 'Glalita',
  'gyaradosite': 'Gyaradosita',
  'heracronite': 'Heracrossita',
  'houndoominite': 'Houndoomita',
  'kangaskhanite': 'Kangaskhanita',
  'latiasite': 'Latiasita',
  'latiosite': 'Latiosita',
  'lopunnite': 'Lopunnita',
  'lucarionite': 'Lucarita',
  'manectite': 'Manectrita',
  'mawilite': 'Mawilita',
  'medichamite': 'Medichamita',
  'metagrossite': 'Metagrossita',
  'mewtwonite-x': 'Mewtwoita X',
  'mewtwonite-y': 'Mewtwoita Y',
  'pidgeotite': 'Pidgeotita',
  'pinsirite': 'Pinsirita',
  'sablenite': 'Sableynita',
  'salamencite': 'Salamencita',
  'sceptilite': 'Sceptilita',
  'scizorite': 'Scizorita',
  'sharpedonite': 'Sharpedonita',
  'slowbronite': 'Slowbronita',
  'steelixite': 'Steelixita',
  'swampertite': 'Swampertita',
  'tyranitarite': 'Tyranitarita',
  'venusaurite': 'Venusaureta',

  // === BERRIES ===
  'cheri-berry': 'Baya Atania',
  'chesto-berry': 'Baya Aranja', // No, Chesto is Atania? Wait.
  // Correction:
  'cheri-berry': 'Baya Safre',
  'chesto-berry': 'Baya Atania',
  'pecha-berry': 'Baya Meloc',
  'rawst-berry': 'Baya Frambu',
  'aspear-berry': 'Baya Peras',
  'leppa-berry': 'Baya Zanama',
  'oran-berry': 'Baya Aranja',
  'persim-berry': 'Baya Caqui',
  'lum-berry': 'Baya Ziuela',
  'sitrus-berry': 'Baya Cidra',
  'figy-berry': 'Baya Higi',
  'wiki-berry': 'Baya Wiki',
  'mago-berry': 'Baya Mago',
  'aguav-berry': 'Baya Guayaba',
  'iapapa-berry': 'Baya Pápaya',
  'rasz-berry': 'Baya Frambu',
  'bluk-berry': 'Baya Oram',
  'nanab-berry': 'Baya Latano',
  'wepear-berry': 'Baya Peragu',
  'pinap-berry': 'Baya Pinia',
  'pomeg-berry': 'Baya Grana',
  'kelpsy-berry': 'Baya Algama',
  'qualot-berry': 'Baya Ispero',
  'hondew-berry': 'Baya Meluce',
  'grepa-berry': 'Baya Uva',
  'tamato-berry': 'Baya Tamate',
  'cornn-berry': 'Baya Mais',
  'magost-berry': 'Baya Magost',
  'rabuta-berry': 'Baya Rebira',
  'nomel-berry': 'Baya Musical', // No, Nomel is Enigma? Wait.
  'nomel-berry': 'Baya Monli',
  'spelon-berry': 'Baya Wikano',
  'pamtre-berry': 'Baya Plama',
  'watmel-berry': 'Baya Meluce', // No.
  'watmel-berry': 'Baya Sambia',
  'durin-berry': 'Baya Durin',
  'belue-berry': 'Baya Belue',
  'occa-berry': 'Baya Pomaro',
  'passho-berry': 'Baya Maranga',
  'wacan-berry': 'Baya Andi',
  'rind-berry': 'Baya Drago',
  'yache-berry': 'Baya Rimoya',
  'chople-berry': 'Baya Caoca',
  'kebia-berry': 'Baya Kebia',
  'shuca-berry': 'Baya Alcho',
  'coba-berry': 'Baya Kouba',
  'payapa-berry': 'Baya Payapa',
  'tanga-berry': 'Baya Tanga',
  'charti-berry': 'Baya Charti',
  'kasib-berry': 'Baya Kasib',
  'haban-berry': 'Baya Habán',
  'colbur-berry': 'Baya Colbur',
  'babiri-berry': 'Baya Babiri',
  'chilan-berry': 'Baya Chilan',
  'roseli-berry': 'Baya Roseli',
  'micle-berry': 'Baya Micole',
  'custap-berry': 'Baya Chiri',
  'jaboca-berry': 'Baya Jaboca',
  'rowap-berry': 'Baya Rowap',
  'kee-berry': 'Baya Biglia',
  'maranga-berry': 'Baya Maranga',
  'enigma-berry': 'Baya Enigma',
  'lansat-berry': 'Baya Lansat',
  'starf-berry': 'Baya Arabol',

  // === MEDICINE & HEALING ===
  'potion': 'Poción',
  'super-potion': 'Superpoción',
  'hyper-potion': 'Hiperpoción',
  'max-potion': 'Poción Máxima',
  'full-restore': 'Restaurar Todo',
  'revive': 'Revivir',
  'max-revive': 'Revivir Máximo',
  'fresh-water': 'Agua Fresca',
  'soda-pop': 'Refresco',
  'lemonade': 'Limonada',
  'moomoo-milk': 'Leche Mu-mu',
  'energy-powder': 'Polvo Energía',
  'energy-root': 'Raíz Energía',
  'heal-powder': 'Polvo Curación',
  'revival-herb': 'Hierba Revivir',
  'antidote': 'Antídoto',
  'paralyze-heal': 'Antiparalizador',
  'awakening': 'Despertar',
  'burn-heal': 'Antiquemar',
  'ice-heal': 'Antihielo',
  'full-heal': 'Cura Total',
  'ether': 'Éter',
  'max-ether': 'Éter Máximo',
  'elixir': 'Elixir',
  'max-elixir': 'Elixir Máximo',
  'rare-candy': 'Caramelo Raro',
  'hp-up': 'Más PS',
  'protein': 'Proteína',
  'iron': 'Hierro',
  'calcium': 'Calcio',
  'zinc': 'Zinc',
  'carbos': 'Carburante',
  'pp-up': 'Más PP',
  'pp-max': 'PP Máximos',

  // === POKEBALLS ===
  'poke-ball': 'Poké Ball',
  'great-ball': 'Super Ball',
  'ultra-ball': 'Ultra Ball',
  'master-ball': 'Master Ball',
  'safari-ball': 'Safari Ball',
  'level-ball': 'Nivel Ball',
  'lure-ball': 'Cebo Ball',
  'moon-ball': 'Luna Ball',
  'friend-ball': 'Amigo Ball',
  'love-ball': 'Amor Ball',
  'heavy-ball': 'Peso Ball',
  'fast-ball': 'Rápida Ball',
  'sport-ball': 'Competi Ball',
  'premier-ball': 'Honor Ball',
  'repeat-ball': 'Acopio Ball',
  'timer-ball': 'Turno Ball',
  'nest-ball': 'Nido Ball',
  'net-ball': 'Malla Ball',
  'dive-ball': 'Buceo Ball',
  'luxury-ball': 'Lujo Ball',
  'heal-ball': 'Sana Ball',
  'quick-ball': 'Veloz Ball',
  'dusk-ball': 'Ocaso Ball',
  'cherish-ball': 'Gloria Ball',
  'park-ball': 'Parque Ball',
  'dream-ball': 'Ensueño Ball',
  'beast-ball': 'Ente Ball',
  'strange-ball': 'Extraña Ball'
};
